import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import BatchErrors from './BatchErrors';
import BatchProperties from './BatchProperties';
import BatchConfig from './BatchConfig';
import BatchContext from '../BatchContext';

const BatchDetails = () => {
  const { batch, isFetchingBatch } = useContext(BatchContext);
  const { config = {} } = batch ?? {};

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={4} xl={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <BatchProperties isLoading={isFetchingBatch} />
          </Grid>
          {Object.keys(config).length > 0 && (
            <Grid item xs={12}>
              <BatchConfig isLoading={isFetchingBatch} />
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12} lg={8} xl={9}>
        <BatchErrors />
      </Grid>
    </Grid>
  );
};

export default BatchDetails;
